import { apiClient } from './apiClient';

export const getCompanyDetails = async () => {
  try {
    const response = await apiClient.get(`/api/v1/company`);
    return response.data.data || null;
  } catch (error) {
    console.error('Failed to fetch company details:', error);
    return null;
  }
};

export const saveCompanyDetails = async (formData) => {
  try {
    // Prepare payload
    const payload = {
      companyName: formData.companyName || '',
      address: formData.address || '',
      country: formData.country || '',
      state: formData.state || '',
      city: formData.city || '',
      pincode: formData.pincode || '',
      contactNo1: formData.contactNo1 || '',
      contactNo2: formData.contactNo2 || '',
      email: formData.email || '',
      website: formData.website || '',
      panNo: formData.panNo || '',
      gstNo: formData.gstNo || '',
      regCin: formData.regCin || '',
      ifcCode: formData.ifcCode || '',
      lutNo: formData.lutNo || '',
      intermediaryBank: {
        bankName: formData.intermediaryBank?.bankName || '',
        routedThrough: formData.intermediaryBank?.routedThrough || '',
        accountName: formData.intermediaryBank?.accountName || '',
      },
      bankDetails: Array.isArray(formData.bankDetails) ? formData.bankDetails : [],
    };

    // If there's a file, use FormData; otherwise, use JSON
    if (formData.companyLogo instanceof File) {
      const data = new FormData();
      
      // Add non-nested fields directly
      data.append('companyName', payload.companyName);
      data.append('address', payload.address);
      data.append('country', payload.country);
      data.append('state', payload.state);
      data.append('city', payload.city);
      data.append('pincode', payload.pincode);
      data.append('contactNo1', payload.contactNo1);
      data.append('contactNo2', payload.contactNo2);
      data.append('email', payload.email);
      data.append('website', payload.website);
      data.append('panNo', payload.panNo);
      data.append('gstNo', payload.gstNo);
      data.append('regCin', payload.regCin);
      data.append('ifcCode', payload.ifcCode);
      data.append('lutNo', payload.lutNo);
      
      // Send nested objects as JSON strings
      data.append('intermediaryBank', JSON.stringify(payload.intermediaryBank));
      data.append('bankDetails', JSON.stringify(payload.bankDetails));
      
      // Add file
      data.append('companyLogo', formData.companyLogo);

      const response = await apiClient.post(`/api/v1/company`, data);
      return response.data;
    } else {
      // No file, send as JSON
      const response = await apiClient.post(`/api/v1/company`, payload);
      return response.data;
    }
  } catch (error) {
    console.error('Failed to save company details:', error);
    throw error;
  }
};

